import clsx from 'clsx';

type Bases = [boolean, boolean, boolean];
// type Outs = 0 | 1 | 2 | 3;

export const BasesOuts = ({
  bases = [false, false, false],
  outs = 0,
  className,
}: {
  bases: Bases;
  outs: number;
  className?: string;
}) => {
  return (
    <div className={clsx('flex items-center justify-center', className)}>
      <svg
        className="h-full w-auto"
        width="52"
        height="59"
        viewBox="0 0 52 59"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Bases */}
        <rect
          fill={bases[2] ? 'white' : undefined}
          x="30.6148"
          y="25.0605"
          width="14.2955"
          height="14.2955"
          transform="rotate(-45 30.6148 25.0605)"
          stroke="white"
          strokeWidth="1.16088"
        />
        <rect
          fill={bases[1] ? 'white' : undefined}
          x="15.8912"
          y="10.9297"
          width="14.2955"
          height="14.2955"
          transform="rotate(-45 15.8912 10.9297)"
          stroke="white"
          strokeWidth="1.16088"
        />
        <rect
          fill={bases[0] ? 'white' : undefined}
          x="1.16755"
          y="25.0605"
          width="14.2955"
          height="14.2955"
          transform="rotate(-45 1.16755 25.0605)"
          stroke="white"
          strokeWidth="1.16088"
        />
        {/* Outs */}
        <circle
          fill={outs > 0 ? 'white' : undefined}
          cx="8.26751"
          cy="52.7734"
          r="5.64605"
          stroke="white"
          strokeWidth="1.16088"
        />
        <circle
          fill={outs > 1 ? 'white' : undefined}
          cx="25.999"
          cy="52.7734"
          r="5.64605"
          stroke="white"
          strokeWidth="1.16088"
        />
        <circle
          fill={outs > 2 ? 'white' : undefined}
          cx="43.7314"
          cy="52.7734"
          r="5.64605"
          stroke={'white'}
          strokeWidth="1.16088"
        />
      </svg>
    </div>
  );
};
